import React from "react";
import ContactForm from "../components/ContactForm";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div>
      <section className="hero-blue py-20 px-5">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl font-extrabold text-white" style={{fontFamily:'Outfit'}}>Contact <span style={{color:'var(--accent-yellow)'}}>Optivize</span></h1>
          <p className="text-blue-100 mt-4 text-lg">We'd love to hear about your project. Let's build it together.</p>
        </div>
      </section>

      <section className="py-16 px-5">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="text-3xl font-bold text-white mb-4" style={{fontFamily:'Outfit'}}>Get in Touch</h2>
            <p className="text-slate-400 leading-relaxed mb-8">
              Whether you're starting a new project or scaling an existing one, our team is ready to help.
              Reach out and we'll get back to you within 24 hours.
            </p>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="icon-tile shrink-0"><Mail size={20}/></div>
                <div>
                  <div className="text-white font-semibold">Email</div>
                  <div className="text-slate-400">support@optivize.digital</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="icon-tile shrink-0"><Phone size={20}/></div>
                <div>
                  <div className="text-white font-semibold">Phone</div>
                  <div className="text-slate-400">+91 99999 99999</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="icon-tile shrink-0"><MapPin size={20}/></div>
                <div>
                  <div className="text-white font-semibold">Headquarters</div>
                  <div className="text-slate-400">Surajit Majhi HUF, India</div>
                </div>
              </div>
            </div>
          </div>
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
